export const imperialDietHouseList = [
  { id: 1, value: '貴族院' },
  { id: 2, value: '衆議院' },
]
